import { type UseQueryResult, useQuery } from 'react-query';
import { RetirementEligibilityConfigurationService } from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useEligibilityCriteriaOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const eligibilityCriteriaOptions = useQuery(
    ['getEligibilityCriteriaOptions'],
    async () => {
      return await handleRequest(
        RetirementEligibilityConfigurationService.getApiAwardSettlementApiAppRetirementEligibilityConfigurationRetirementEligibilityCriterias()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return eligibilityCriteriaOptions;
};

export default useEligibilityCriteriaOptions;
